export default __webpack_public_path__ + "18fc6268d5cfaa09dc357ebf9916220f.png";